/* eslint-disable */
import config from "../../config";
import makeAPIRequest from "../../services/makeRequest";

/**
 * Fetch Salesforce ↔ OfficeRnD comparison with pagination and optional filters
 *
 * @param {string} accessToken
 * @param {number} page
 * @param {number} limit
 * @param {Object} filters Optional filters { market: string, location: string, search: string }
 * @param {string} mode Optional, default "main"
 * @returns {Promise<Object>} Raw JSON response from backend
 */
async function getOfficerndComparison(accessToken, page = 1, limit = 20, filters = {}, mode = "main") {
    if (!accessToken) throw new Error("Access token is required.");

    let API_ENDPOINT = `${config.API_BASE_ENDPOINT}/admin/officernd/salesforce-officernd-matching?page=${page}&limit=${limit}&mode=${mode}`;

    // Append optional filters
    if (filters.market) API_ENDPOINT += `&market=${encodeURIComponent(filters.market)}`;
    if (filters.location) API_ENDPOINT += `&location=${encodeURIComponent(filters.location)}`;
    if (filters.search) API_ENDPOINT += `&search=${encodeURIComponent(filters.search)}`; // <-- Add this

    const response = await makeAPIRequest(API_ENDPOINT, "GET", null, accessToken);
    const jsonResponse = await response.json();

    if (!jsonResponse || jsonResponse.status !== "success") {
        throw new Error("Failed to fetch comparison data from server.");
    }

    return jsonResponse;
}

export default getOfficerndComparison;
